<nav class="navbar navbar-expand navbar-inverse bg-dark px-2">
    <div class="side-nav-button p-2 me-3 text-light" (click)="sideNavToggle()">
        <div class="icon-list-menu" style="color: white;" ></div>
    </div>
    <a tabindex="0" class="header__logo">
        <span class="icon-cisco"></span>
    </a>
    <div class="navbar-brand px-9">
        Secure Firewall Application Detectors
    </div>

    <div class="feedback_icon ml-auto" style="height: 23px;margin-left: auto; ">
        <a class="tab-group__link" routerLink (click)="openModal('desktopModal')"> <img src="./assets/images/feedback_icon.png"> </a>
    </div>
   
    
  </nav>

<div id="desktopModal" class="modal rating modal-alligment">
    <div class="modal__dialog">
        <div class="modal__content">
            <div class="modal__header">
                <div class="modal__title">Feedback</div>
                <a class="modal__close" (click)="closeModal('desktopModal')"><span class="icon-close"></span></a>
            </div>
            <div class="modal__body container-fluid">
                <p class="scale_text">On a scale of 0 to 10, how likely are you likely to recommend this tool to a
                    friend or a colleague?
                </p>

                <div class="row paddings" >
                    <div  *ngFor="let count of buttonArr">
                        <!-- <button ngDefaultControl  [(ngModel)]="scaleCount" [ngStyle]="{'background-color':getColor(count)}" class="pagination__item pagination__link--type-bordered" mat-raised-button (click)="selectScore(count)">{{count}}</button> -->
                        <button ngDefaultControl
                            [ngClass]="[scaleCount==count+'' ? 'btn--state-selected' :'' ,showScale ? 'showWarningRed'  : '']"
                            [(ngModel)]="scaleCount"
                            class="pagination__item pagination__link--type-bordered mat-raised-button_header"
                            (click)="selectScore(count)">{{count}}</button>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">  <div class="paddings_notlikely">Not likely</div></div>
                    <div class="col-md-3">  <div class="paddings_neutral">Neutral</div> </div>
                    <div class="col-md-2"></div>
                    <div class="col-md-4">  <div class="paddings_extremelylikely">Extremly likely</div> </div>
                </div>

                <div class="row"><label class="scale_text paddings_label">What can we do better?</label></div>
                <textarea ngDefaultControl [(ngModel)]="feedBackDescription" class="feedbackdescription"
                    [ngClass]="showDescription ? 'showWarningRed'  : ''"> </textarea>


                <div class="row"><label class="useremailcolor paddings_label">Email</label></div>
                <input type="text" class="useremail" [(ngModel)]="email"
                    [ngClass]="showEmail ? 'showWarningRed'  : ''" />
                <p>
                    <label class="checkbox">
                        <input type="checkbox" class="checkbox__input" checked ngDefaultControl
                            [(ngModel)]="contactPersmission">
                        <div class="checkbox__box"></div>
                        <div class="checkbox__label scale_text">May we contact you regarding your feedback?</div>
                    </label>
                    <!-- <label class="checkbox">
                        <input type="checkbox" class="checkbox__input">
                        <div class="checkbox__box"></div>
                        <div class="checkbox__label scale_text">Do not show me this again</div>
                    </label> -->
                </p>
                <!--
                <div [ngClass]="showScale ? 'showWarningsBlock'  : 'showWarningsNone'">Please select a scale from 0 to
                    10.</div>
                <div [ngClass]="showDescription ? 'showWarningsBlock'  : 'showWarningsNone'">Please share your
                    description.</div>
                <div [ngClass]="showEmail ? 'showWarningsBlock'  : 'showWarningsNone'">Please enter valid email, so we
                    can contact you.</div>
                 -->   
            </div>
            <div class="modal__footer">
                <!-- <div class="row"> -->
                <div class="col-md-6" style="text-align: left; ">
                    <a href="http://www.cisco.com/web/siteassets/legal/privacy.html" target="_blank"><span
                            class="privacypolicy" style="color:#0083B3 ; font-size: 14px;font-weight: 700; padding-right: 7px;">Privacy Policy</span>
                        <svg width="15" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" style="color:  #7E868F; height : 18.75px">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M8.94833 8.9475H1.0525V1.05167H5.52667V0H0.526667C0.236667 0 0 0.235833 0 0.526667V9.47333C0 9.76333 0.236667 10 0.526667 10H9.47333C9.76417 10 10 9.76333 10 9.47333V4.47333H8.94833V8.9475ZM9.13254 3.14794C9.25679 3.27219 9.38185 3.23214 9.41127 3.05966L9.9998 0L6.93375 0.582013C6.76128 0.611441 6.72123 0.737326 6.84466 0.861576L7.62608 1.64304L5.98394 3.28527C5.78286 3.48636 5.78286 3.81415 5.98394 4.01524C6.18584 4.21714 6.51198 4.21714 6.71387 4.01524L8.35683 2.37219L9.13254 3.14794Z"
                                fill="#58585B" />
                        </svg>
                    </a>
                </div>

                <div class="col-md-6" style="text-align: right;">
                    <button class="btn btn--secondary" (click)="closeModal('desktopModal')">Close</button>
                    <button class="btn btn--primary" (click)="submitFeedback()">Submit</button>
                </div>

                <!-- </div> -->


            </div>
        </div>
    </div>
</div>
